import { render } from "./PublicationsWrapper.vue?vue&type=template&id=5f60c3a6"
import script from "./PublicationsWrapper.vue?vue&type=script&lang=js"
export * from "./PublicationsWrapper.vue?vue&type=script&lang=js"

import "./PublicationsWrapper.vue?vue&type=style&index=0&id=5f60c3a6&lang=scss"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__